import { Exclude } from 'class-transformer';

export class AttachmentRawDto {
    fileName: string;
    action: string; // Add, Delete
    fileBase64String: string;
    fileId: number;
    communityId: number;
    customerId: string;

    // Transient
    @Exclude()
    fileUrl: string;

    // reffered as local attachement file name
    @Exclude()
    name: string;
}
